import { z } from 'zod';

// security-privacy.md §4: the CSP has no `'unsafe-eval'`. Without `jitless`, zod probes `new Function`
// on its first object parse and the browser reports a `script-src` violation (zod swallows the error,
// the report stays). Import this module first in every document that parses with zod.
z.config({ jitless: true });
